import { URLS } from "@app/shared";
import { Link } from "@design-system/components";
import { getCurrentLocaleCode, trans } from "@mongez/localization";
import { ArrowRight } from "lucide-react";
import { toolLocales } from "../utils";

/**
 * Company Announcements — Section 10 of the approved IR content sheet.
 * Dynamic content: the existing Euroland press-releases feed, unchanged.
 */
export function LatestDisclosures() {
  const locale = getCurrentLocaleCode();
  const { standard } = toolLocales(locale);

  return (
    <section
      aria-labelledby="company-announcements-title"
      className="container pb-14 lg:pb-16"
    >
      <div className="flex flex-col gap-6">
        <h2
          id="company-announcements-title"
          className="text-2xl font-bold text-marine sm:text-3xl"
        >
          {trans("latestDisclosures.heading")}
        </h2>

        <euroland-tool
          data-tool-name="PressReleases"
          data-tool-version="ticker"
          data-tool-language={standard}
        />

        <Link
          to={URLS.investor.companyAnnouncements}
          className="group mx-auto inline-flex w-fit items-center gap-2 rounded-full bg-steel px-5 py-3 text-sm font-bold uppercase tracking-wider text-white transition-colors duration-300 hover:bg-steel/80 sm:px-6 sm:py-3.5 sm:text-base"
        >
          {trans("viewAllCompanyAnnouncements")}
          <ArrowRight
            className="h-4 w-4 shrink-0 transition-transform duration-300 group-hover:translate-x-0.5 rtl:rotate-180 rtl:group-hover:-translate-x-0.5"
            aria-hidden
          />
        </Link>
      </div>
    </section>
  );
}
